import {
	PROJECT_COMMENTS_FORM_MODULE_ID,
} from 'root/src/shared/descriptions/modules/moduleIds'

import addComment from 'root/src/client/logic/comment/thunks/addComment'
import addCommentOnSuccess from 'root/src/client/logic/project/thunks/addCommentOnSuccess'

export default {
	[PROJECT_COMMENTS_FORM_MODULE_ID]: [
		{
			action: addComment,
			onSuccess: addCommentOnSuccess,
		},
	],
}
